module.exports = __webpack_public_path__ + "static/media/gt-bank-wallet.8436b5e0.svg";